import { ContextCinema } from "./contextCinema";

const cinema = new ContextCinema();
cinema.init();
